import { isArray, xor } from 'lodash'

const toggleLoading = (loading: any[], toggle: any[] | any) => {
  return xor(loading, isArray(toggle) ? toggle : [toggle])
}

export default toggleLoading
